import React from 'react'
import { BackTop } from 'antd'


import './common.css'

class LinestickerFooter extends React.Component {
    render() {
        return (
            <div className="contain-fluid">
                <div className="outsideFooter">
                    <div className="copyright">本辦法若在徵選活動期間有未盡事宜，主辦單位得隨時修訂並於活動網站公佈之</div>
                    <div className="copyright">指導單位：校長室 / 主辦單位：通識中心</div>
                    <div className="copyright">協辦單位：視傳系、漫畫系、多動系、秘書室 / 系統設計：網資中心(雲端應用組) <a href='https://nic.tut.edu.tw/p/406-1012-5113,r61.php?Lang=zh-tw' target='_blank' rel="noreferrer" style={{ color: "white", textDecoration: "underline" }}>曾秋榮先生</a></div>
                    <div className="copyright">Copyright &copy; 2022 台南應用科技大學</div>
                    <BackTop>
                        <div className="goTop" style={{ fontSize: "16px" }}>UP</div>
                    </BackTop>
                </div>
            </div>
        )
    }
}


export default LinestickerFooter